/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampShowResponse2 } from '../../models/camp-show-response-2';

export interface DeleteCampRemove$Params {
  name: string;
}

export function deleteCampRemove(http: HttpClient, rootUrl: string, params: DeleteCampRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<CampShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, deleteCampRemove.PATH, 'delete');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampShowResponse2>;
    })
  );
}

deleteCampRemove.PATH = '/v1/camp/{name}';
